/**
 * @module app.cd
 */

import { autoinject } from 'aurelia-framework';
import { RouteConfig } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { MemberService } from 'app/cd/services/member-service';
import * as CD from 'app/cd/models/essette-api';

@autoinject()
export class MemberSummaryPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected memberId: string | null = null;
    protected member: CD.Member | null = null;
    protected planId: string | null = null;
    protected readonly: boolean = true;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: MemberService,
        private readonly i18n: I18N,
        ...rest: any[]) {
        super(...rest);
    }

    protected async canActivate(): Promise<boolean> {
        await this.accountContext.load();
        return this.accountContext.hasRouteAccess('cd.member.summary');
    }

    protected async activate(params: { memberId: string, planId: string }, routeConfig: RouteConfig): Promise<void> {
        if(!params?.memberId && !params?.planId) {
            throw new Error('Missing required parameters: memberId or planId');
        }

        this.memberId = params.memberId;
        this.planId = params.planId;

        await this.reload();

        if(this.member && routeConfig.navModel) {
            const title = this.i18n.tr('cd:routes.member.summary.$title', { display: this.member.$display });
            routeConfig.navModel.setTitle(title);
        }
    }

    ////****************** Events ***************************************************////
    public async reload(): Promise<void> {
        await this.loadMember();
    }

    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadMember(): Promise<void> {
        if(!this.memberId && !this.planId) return;

        const fields = [
            'description'
        ];

        try {
            this.state.beginLoad();
            const response = this.planId ?
                await this.service.loadMemberByPlan(this.planId, [], fields) :
                await this.service.loadMember(this.memberId!, [], fields);
            this.member = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
